<template>
  <div>
    <figure class="msg tripla">
      <p class="chat-message" v-html="formatChatMessage"></p>
    </figure>
    <ul v-show="active" :class="style['select-options']">
      <li :class="style.thumbs" @click="sendEvaluation('good')"></li>
      <li :class="style.thumbs" @click="sendEvaluation('bad')"></li>
    </ul>
  </div>
</template>

<script>
import ActionWidget from './ActionWidget.vue'
import { Chat } from 'src/apis'
import style from './scss/_select_options.scss'

export default {
  extends: ActionWidget,
  computed: {
    style: () => style
  },
  methods: {
    sendEvaluation(rating) {
      this.active = false
      Chat.SendUserEval(this.chat.id, rating).catch((err) => {
        console.error(err)
        this.active = true
      })
    }
  }
}
</script>
